<template>
  <div class="yuncangIndex">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="listL">
      <div
        class="hederBg"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <van-nav-bar
          title="国际轻奢馆"
          left-arrow
          @click-left="onClickLeft"
          @click-right="onClickRight"
          right-text="说明"
        />
        <div class="searchBox">
          <van-search
            v-model="keyWord"
            placeholder="请输入搜索关键词"
            @click="searchBS()"
            readonly
          />
        </div>
      </div>
      <div class="main" :style="{ top: (isiOSX ? 98 + 44 : 98 + 24) + 'px' }">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item
            v-for="(item, index) in swiper"
            :key="index"
            @click="goRouterBS(item.href)"
          >
            <img :src="item.img_url" alt="" />
          </van-swipe-item>
        </van-swipe>
        <!-- 导航 -->
        <div class="nav">
          <ul>
            <li
              v-for="(item, index) in navList"
              :key="index"
              v-if="item.status == 1"
              @click="tapNav(item)"
            >
              <img :src="item.icon" alt="" />
              <p>{{ item.name }}</p>
            </li>
            <li @click="allClassify()">
              <img src="../../assets/yuncang/icon-04.png" alt="" />
              <p>全部分类</p>
            </li>
          </ul>
        </div>
        <!-- 导航 -->
        <!-- 商品列表 -->
        <div class="goodsList">
          <h2>
            {{ title }}
            <span>{{ subTitle }}</span>
          </h2>

          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="别拉了，小巴也是有底线的"
            @load="onLoad"
          >
            <van-row gutter="5">
              <van-col span="12">
                <div
                  class="goodsItem"
                  v-for="(item, index) in listL"
                  @click="goDetailBS(item.id)"
                  :key="index"
                >
                  <div class="thumbBox" :style="goodsImgHeight">
                    <img class="thumb" :src="item.thumb" alt="" />
                  </div>
                  <h4>
                    <img v-if="item.label" :src="item.label" alt="" />
                    {{ item.name }}
                  </h4>
                  <div class="goodsMsg">
                    <strong><i>￥</i>{{ item.activity_min_price }}</strong>
                    <span>仅剩{{ item.inventory }}件</span>
                  </div>
                </div>
              </van-col>
              <van-col span="12">
                <div
                  class="goodsItem"
                  v-for="(item, index) in listr"
                  :key="index"
                  @click="goDetailBS(item.id)"
                >
                  <div class="thumbBox" :style="goodsImgHeight">
                    <img class="thumb" :src="item.thumb" alt="" />
                  </div>
                  <h4>
                    <img v-if="item.label" :src="item.label" alt="" />
                    {{ item.name }}
                  </h4>
                  <div class="goodsMsg">
                    <strong><i>￥</i>{{ item.activity_min_price }}</strong>
                    <span>仅剩{{ item.inventory }}件</span>
                  </div>
                </div>
              </van-col>
            </van-row>
          </van-list>
        </div>
        <!-- 商品列表 -->
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      goodsImgHeight: {
        height: (document.body.clientWidth - 29) / 2 + "px",
      },
      isiOSX: false,
      categoryList: [],
      swiper: [],
      page: 0,
      keyWord: "",
      loading: false,
      finished: false,
      isLoading: false,
      listL: [],
      listr: [],
      allList: null,
      navList: [],
      title: null,
      subTitle: null,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onClickRight() {
      this.$router.push({
        path: "/yuncang/explain",
      });
    },
    onClickLeft() {
      this.params("", "", "goBack");
    },
    allClassify() {
      this.$router.push({
        path: "/yuncang/classify",
      });
    },
    //获取分类列表
    getIndexNav() {
      this.$api
        .post("/ongoods/index/yc/index-nav", { tag: "yc_icon_nav" })
        .then((res) => {
          this.navList = res.list;
        });
    },
    //获取广告banner
    getAdList() {
      this.$api
        .post("/adspace/index/get/ad/list", {
          labels: ["shallBuy_YunCang_index_banner"],
        })
        .then((res) => {
          if (
            res.shallBuy_YunCang_index_banner &&
            res.shallBuy_YunCang_index_banner.length > 0
          ) {
            this.swiper = res.shallBuy_YunCang_index_banner;
          }
        });
    },
    // 获取商品列表
    getGoodsList() {
      this.$api
        .post("/ongoods/index/goods/guess-like", {
          self_id: 100,
          page: this.page,
          pageSize: 8,
        })
        .then((res) => {
          this.allList = res.total;
          this.title = res.config.title;
          this.subTitle = res.config.sub_title;
          if (Object.prototype.toString.call(res.list) == "[object Array]") {
            res.list.forEach((_, i) => {
              if (i % 2 == 0) {
                this.listL.push(_);
              } else {
                this.listr.push(_);
              }
            });
          }
          this.loading = false;
          if (this.listL.length + this.listr.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
    goDetailBS(id) {
      //商品详情
      let params = {
        goodsId: id,
        shopId: 4,
      };
      this.params(JSON.stringify(params), JSON.stringify(params), "goDetailBS");
    },
    //跳转广告路由
    goRouterBS(router) {
      if (router) {
        let params = {
          route_url: router,
          shopId: 4,
        };
        this.params(
          JSON.stringify(params),
          JSON.stringify(params),
          "goRouterBS"
        );
      }
    },
    searchBS() {
      this.$router.push({
        path: "/yuncang/search",
      });
    },
    //点击导航
    tapNav(data) {
      if (data.route.url && data.route.url.indexOf("yuncang/goodsList") != -1) {
        this.$router.push({
          path: data.route.url,
        });
      } else {
        this.goRouterBS(data.route.url);
      }
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getGoodsList();
        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.listL = [];
      this.listr = [];
      this.getGoodsList();
      this.getIndexNav();
      this.getAdList();
    },
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.isiOSX = this.isIphoneX();
    this.getIndexNav();
    this.getAdList();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.yuncangIndex {
  background: #f5f6f7;
  height: 100%;
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;

  .van-pull-refresh {
    height: 100%;
    overflow-y: scroll;
  }
  .hederBg {
    background: #161210;
    height: 156px;
    .searchBox {
      margin: 10px 0;
      padding: 0 12px;
      height: 34px;
      .van-search {
        height: 34px;
        line-height: 34px;
        border-radius: 17px;
        padding: 0px 0px;
        width: 100%;
        .van-search__content {
          background-color: #ffffff;
          border-radius: 17px;
        }
      }
    }
  }
  .main {
    position: absolute;
    left: 0;
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    .my-swipe {
      height: auto;
      border-radius: 6px;
      box-shadow: 0px 0px 10px 5px rgba(194, 188, 152, 0.28);
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
    .nav {
      background: #ffffff;
      margin-top: 10px;
      border-radius: 6px;
      box-shadow: 2px 2px 6px 0px rgba(230, 218, 212, 0.3);
      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        padding-bottom: 12px;
        li {
          width: 20%;
          text-align: center;
          margin-top: 12px;
          img {
            width: 44px;
            height: 44px;
          }
          p {
            color: #333333;
            font-size: 12px;
            line-height: 17px;
            margin-top: 5px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
    .goodsList {
      h2 {
        margin: 20px 0 10px;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
        span {
          font-size: 14px;
        }
      }
      .goodsItem {
        background: #ffffff;
        border-radius: 6px;
        padding-bottom: 10px;
        margin-bottom: 5px;
        overflow: hidden;
        .thumbBox {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .thumb {
          max-width: 100%;
          max-height: 100%;
        }
        h4 {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          padding: 0 10px;
          margin: 10px 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-all;
          height: 44px;
          img {
            height: 14px;
            // float: left;
            margin-right: 8px;
          }
        }
        .goodsMsg {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          padding: 0 10px;
          line-height: 18px;
          strong {
            font-weight: 500;
            color: #f41a3c;
            font-size: 18px;
            i {
              font-size: 14px;
              font-style: normal;
            }
          }
          span {
            font-size: 11px;
            font-weight: 400;
            color: #999999;
            line-height: 16px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
body {
  height: 100% !important;
}
.yuncangIndex {
  .van-nav-bar__text:active {
    background: none;
  }
  .van-nav-bar {
    background: none;
    height: 44px;
    .van-nav-bar__left {
      .van-icon {
        color: #ffffff;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: #ffffff;
      font-weight: 600;
    }
    .van-nav-bar__right {
      .van-nav-bar__text {
        color: #ffffff;
        font-size: 13px;
      }
    }
  }
  [class*="van-hairline"]::after {
    border-bottom: none;
  }
  .van-swipe__indicator {
    width: 4px;
    height: 4px;
    background-color: #ffffff;
    opacity: 1;
    margin-right: 2px;
  }
  .van-swipe__indicator--active {
    width: 12px;
    height: 4px;
    background-color: #f9591b !important;
    border-radius: 2px;
    margin-right: 2px;
  }
  .van-icon-search::before {
    content: "";
    width: 19px;
    height: 19px;
    background: url("../../assets/yuncang/icon-07.png") no-repeat;
    background-size: 100%;
  }
  .van-field__left-icon {
    margin-right: 7px;
  }
  .van-field__control::-webkit-input-placeholder {
    color: #999999;
  }
  .van-field__control::-moz-placeholder {
    color: #999999;
  }
  .van-field__control::-moz-placeholder {
    color: #999999;
  }
  .van-field__control::-ms-input-placeholder {
    color: #999999;
  }
}
</style>